import { Component, OnInit, Input } from '@angular/core';
import * as PrismicDOM from 'prismic-dom';
import * as _ from 'lodash';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  @Input() projects: string;
  @Input() reversed: boolean;


  public portfolio;

  public activeProject;
  public activeIndex = 0;
  public tempDisappear = [];

  public incrementIndex() {
    if (this.activeIndex + 1 < this.projects.length) {
      let i = this.activeIndex;
      let self = this;
      self.tempDisappear[i] = true;
      setTimeout(function () {
        // console.log("tempDisappear: ", self.tempDisappear);
        self.tempDisappear[i] = false;
      }, 400);
      this.activeIndex++;
      this.activeProject = this.projects[this.activeIndex];;
    }

  }
  public decrementIndex() {
    if (this.activeIndex > 0) {
      let i = this.activeIndex;
      let self = this;
      self.tempDisappear[i] = true;
      setTimeout(function () {
        // console.log("tempDisappear: ", self.tempDisappear);
        self.tempDisappear[i] = false;
      }, 400);
      this.activeIndex--;
      this.activeProject = this.projects[this.activeIndex];
    }

  }

  public setActive(project) {
    if (this.activeProject !== project) {
      let i = this.activeIndex;
      let self = this;
      self.tempDisappear[i] = true;
      setTimeout(function () {
        // console.log("tempDisappear: ", self.tempDisappear);
        self.tempDisappear[i] = false;
      }, 400);
      // console.log("setActive: ", project);
      this.activeProject = project;
      this.activeIndex = _.findIndex(this.projects, (p) => p === this.activeProject);
      // console.log("activeIndex: ", this.activeIndex);
    }

  }


  public generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }

  constructor() { }

  ngOnInit() {
    // console.log("PROJECTS: ", this.projects);
    this.activeProject = this.projects[0]; 
    this.activeIndex = 0;
  }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/portfolio/projects/projects.component.ts